import React from 'react';

// new components
const SignIn = React.lazy(() => import('../Features/Auth/SignIn'));
const SignUp = React.lazy(() => import('../Features/Auth/SignUp'));
const ForgotPassword = React.lazy(() => import('../Features/Auth/ForgotPassword'));
const NewPassword = React.lazy(() => import('../Features/Auth/NewPassword'));
const SuccessPage = React.lazy(() => import('../Features/Auth/Success'));
const ErrorPage = React.lazy(() => import('../Features/Auth/Error'));
const TotpVerify = React.lazy(() => import('../Features/Auth/TotpVerify'));

const routes = [
  {
    path: '/auth/sign-in', exact: true, name: 'Sign in', component: SignIn,
  },
  {
    path: '/auth/sign-up/:id/:token', exact: true, name: 'Sign up', component: SignUp,
  },
  {
    path: '/auth/forgot-password', exact: true, name: 'Forgot password', component: ForgotPassword,
  },
  {
    path: '/auth/new-password', exact: true, name: 'New password', component: NewPassword,
  },
  {
    path: '/auth/invite/success', exact: true, name: 'Success page', component: SuccessPage,
  },
  {
    path: '/auth/invite/error', exact: true, name: 'Error page', component: ErrorPage,
  },
  {
    path: '/auth/verify', exact: true, name: 'Totp verify', component: TotpVerify,
  },
];

export default routes;
